import { styled } from 'styled-components';

export const InputRow = styled.div`
  position: relative;
  width: 100%;
  height: 2.4rem;

  span {
    display: block;
    position: absolute;
    height: 1.6rem;
    font-size: ${({ theme }) => theme.typography.bodyMedium.fontSize};
    padding-top: ${({ theme }) => theme.sizing.large};
  }
  span:first-child {
    text-align: left;
    left: 0px;
  }
  span:last-child {
    right: 0px;
    text-align: right;
  }

  & > div {
    display: block;
    position: absolute;
    left: 20%;
    width: 60%;

    > div {
      width: 100%;
    }
  }
`;
InputRow.displayName = 'InputRow';

export const ValidatorRow = styled.div`
  position: relative;
  width: 100%;
  padding: 0 ${({ theme }) => theme.sizing.medium}
    ${({ theme }) => theme.sizing.small};
  height: 3.2rem;
  margin: ${({ theme }) => theme.sizing.small} 0;

  div {
    width: 100%;
    padding: ${({ theme }) => theme.sizing.tiny};
    font-size: ${({ theme }) => theme.typography.bodyMedium.fontSize};
  }
`;
ValidatorRow.displayName = 'ValidatorRow';
